import { ProductQueryParams, ProductDataArray, ProductModel } from '@app/interfaces/product';
import { axiosApi } from './axios.api';
import { apiErrorMessage } from './ApiError';

const url = `/api/products`;

export const getProductsApi = async (params?: ProductQueryParams): Promise<ProductDataArray | undefined> => {
  try {
    const response = await axiosApi.get<ProductDataArray>(url, { params });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const getProductApi = async (productId: number) => {
  try {
    const response = await axiosApi.get(`${url}/${productId}`);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const createProductApi = async (data: ProductModel, config: any) => {
  try {
    const response = await axiosApi.post(url, data, config);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const updateProductApi = async (productId: number, formData: ProductModel, config: any) => {
  try {
    const response = await axiosApi.put(`${url}/${productId}`, formData, config);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const deleteProductApi = async (productId: number) => {
  try {
    const response = await axiosApi.delete(`${url}/${productId}`);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const stopProductApi = async (productId: number) => {
  try {
    const response = await axiosApi.post(`${url}/${productId}/stop`);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const cloneProductApi = async (productId: number) => {
  try {
    const response = await axiosApi.post(`${url}/${productId}/clone`);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const exportProductApi = async (params?: string) => {
  try {
    const response = await axiosApi.get(`${url}/export`, { params, responseType: 'blob' });

    const newUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = newUrl;
    link.setAttribute('download', `products.xlsx`);
    document.body.appendChild(link);
    link.click();
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export interface ProductStockStats {
  negative: number;
  out_of_stock: number;
  low_stock: number;
}

export const getProductStockStatsApi = async (): Promise<ProductStockStats | undefined> => {
  try {
    const response = await axiosApi.get<ProductStockStats>(`${url}/stock_stats`);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const updateProductCostPriceApi = async (productId: number, costPrice: number) => {
  try {
    const formData = new FormData();
    formData.append('cost_price', String(costPrice));
    const response = await axiosApi.put(`${url}/${productId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
    throw error;
  }
};

export interface ProductTransactionParams {
  page?: number;
  per_page?: number;
  inventory_type?: string;
  from_date?: string;
  to_date?: string;
}

export const getProductTransactionsApi = async (productId: number, params?: ProductTransactionParams) => {
  try {
    const response = await axiosApi.get(`${url}/${productId}/transactions`, { params });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const exportProductTransactionsApi = async (productId: number, params?: ProductTransactionParams) => {
  try {
    const response = await axiosApi.get(`${url}/${productId}/transactions_export`, {
      params,
      responseType: 'blob',
    });

    const newUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = newUrl;
    link.setAttribute('download', `product_transactions.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(newUrl);
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const getProductForOrdersApi = async (params?: ProductQueryParams): Promise<ProductDataArray | undefined> => {
  try {
    const response = await axiosApi.get<ProductDataArray>(`${url}/product_for_orders`, { params });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};
